import { render, staticRenderFns } from "./videoModel.vue?vue&type=template&id=64967321&scoped=true"
import script from "./videoModel.vue?vue&type=script&lang=js"
export * from "./videoModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64967321",
  null
  
)

export default component.exports